// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-2734d58e]{width:800px;line-height:1.8em;word-wrap:break-word}h4[data-v-2734d58e]{padding:15px 0}.shsj[data-v-2734d58e]{text-indent:2em}table[data-v-2734d58e]{table-layout:fixed;word-wrap:break-word}a[data-v-2734d58e]{text-decoration:underline;color:#00f}", ""]);
// Exports
module.exports = exports;
